import React, { Component } from "react";
import { connect } from "react-redux";
import { setCurrentNavPage } from "Actions";

import { fetchMed } from "thunks";

import ArchiveComponent from "./ArchiveComponent";
import { resetFilter } from "Actions";

export class Archive extends Component {
  componentDidMount() {
    const { fetchMed, resetFilter } = this.props;
    resetFilter();
    fetchMed({
      type: "ALL",
      limit: 30,
      filterBy: { status: ["ARCHIVED"] }
    });
  }

  render() {
    const { community, medias, filter, fetchMed, resetFilter } = this.props;
    return (
      <div>
        <ArchiveComponent
          medias={medias}
          filter={filter}
          community={community}
          fetchMedias={fetchMed}
          status={["ARCHIVED", "MASKED"]}
          resetFilter={resetFilter}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = (state, ownProps) => ({
  filter: state.filter.filterState,
  medias: state.medias.listing,
  community: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  setCurrentNavPage: options => dispatch(setCurrentNavPage(options)),
  fetchMed: params => dispatch(fetchMed(params)),
  resetFilter: () => dispatch(resetFilter())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Archive);



// WEBPACK FOOTER //
// ./src/components/Archive/index.js